import React from 'react';

export default function OnboardingChecklist() {
  return (
    <div style={{ width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <iframe src="https://little-seahorse-297.notion.site/ebd//2cb1928df74d8046bd92e05102f33a3a" width="100%" height="100%" frameBorder="0" allowFullScreen title="Onboarding Checklist" />
    </div>
  );
}
